import { useLightMode } from '@/hooks/useLightMode'

import { Box, Skeleton, tokenPrefix } from '@hivewatch/dark'

export const DarkEditDeviceSkeleton = () => {
  // v3's Skeleton defaults to the `pulse` variant, whose background is
  // `bg.emphasized` — a token the dark system does not define — so the fill
  // has to be pinned. `pulse` animates opacity, so the shimmer survives.
  const skeletonBg = `${tokenPrefix(useLightMode())}bg.skeleton`

  return (
    <Box data-testid='DarkEditDeviceModal:skeleton'>
      <Skeleton bg={skeletonBg} h='20px' maxW='240px' mb='8px' />
      <Skeleton bg={skeletonBg} h='14px' maxW='520px' mb='20px' />
      <Skeleton bg={skeletonBg} h='36px' mb='16px' />
      <Skeleton bg={skeletonBg} h='36px' mb='16px' />
      <Skeleton bg={skeletonBg} h='36px' />
    </Box>
  )
}
